var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('span',[_vm._v("v"+_vm._s(_vm.$sav.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }